/**
 * Флаги сборки программы «Корпоративные клиенты» (контракт, identifiers.md §6).
 * REACT_APP_B2B_MOCK здесь не экспортируется: CorpSessionService читает его литералом
 * в месте использования — только так webpack выбрасывает ветку мока из prod-сборки (G4).
 */
export const B2B_ENABLED = process.env.REACT_APP_B2B_ENABLED === "true";
